import { Button } from "antd";
import { CurrencyFormat, formatDate } from "../../../components/helpers";

export const convertLoanNonCash = (loanNonCashData, handleOpenPreview) => {
  let convertedLoanNonCash = [];

  if (!loanNonCashData) return [];
  loanNonCashData.forEach((loan, index) => {
    convertedLoanNonCash.push({
      key: index + 1,
      gadaiID: loan?.id,
      dateTime: formatDate(loan.gadai_at) || "-",
      pawnNumber: loan.sbg_code || "-",
      receiptNumber: loan.receipt_code || "-",
      customerName: loan.ktp_name || "-",
      amountReceived: `Rp ${CurrencyFormat(loan.gadai_transfer.amount) || 0}`,
      accountName: loan.gadai_transfer.customer_account_name || "-",
      bankOrAccountNumber:
        `${loan.gadai_transfer.customer_bank_name} / ${loan.gadai_transfer.customer_account_number}` ||
        "-",
      validityProof: loan.gadai_transfer.transfer_proof_picture ? (
        <Button
          onClick={handleOpenPreview(
            `gadai-transfer/${loan?.gadai_transfer?.id}/proof-picture`
          )}
          type="link"
        >
          Lihat File
        </Button>
      ) : (
        "-"
      ),
      processLoanDetail: {
        customerID: loan.customer?.id || "-",
        customerName: loan.customer?.ktp_name || "-",
        gadaiID: loan.id || "-",
        customerEmail: loan.customer?.email || "-",
        customerPhone1: loan.customer?.phone_1 || "-",
        customerPhone2: loan.customer?.phone_2 || "-",
        customerPicture: loan.customer?.customer_picture || null,
        customerNIK: loan.customer?.ktp_number || "-",
        customerGender:
          (loan.customer?.gender?.toLowerCase() === "p"
            ? "Perempuan"
            : "Laki-laki") || "-",
        customerDOB: loan.customer?.birth_date || "-",
        customerAddress: loan.customer?.address || "-",
        customerKTPPicture: loan.customer?.ktp_picture || null,
        bankOrAccountNumber:
          `${loan.gadai_transfer?.customer_bank_name} / ${loan.gadai_transfer?.customer_account_number}` ||
          "-",
        accountName: loan.gadai_transfer?.customer_account_name || "-",
        receiptNumber: loan.receipt_code || "-",
        status: loan.gadai_status,
        customer: loan.customer,
      },
    });
  });
  return convertedLoanNonCash;
};
